import BaseView from './base-view.js';

export default class ModalView extends BaseView {
	constructor({ el, modal_selector, navigation, modal_content }) {
		super(el);

		if (!modal_selector) {
			throw new Error('Missing "modal_selector"!');
		}

		this.navigation = navigation;
		this.modal_selector = modal_selector;
		this.modal_content = modal_content || null;
		this.modal = null;
	}
	get_context () {
		return {
			navigation: this.navigation,
			content: this.modal_content
		};
	}
	after_render () {
		this.once_rendered();
	}
	once_rendered () {}
	isOpened() {}
	isClosed() {}
	open () {
		this.modal.open();
	}
	close () {
		this.modal.close();
	}
	popupOpened () {
		document.body.classList.add('popup-opened');
		this.isOpened();
	}
	popupClosed () {
		document.body.classList.remove('popup-opened');
		this.isClosed();
	}
	init_modal () {
		this.modal = document.querySelector(this.modal_selector);
	}
	init_popup_events () {
		this.modal.addEventListener('open', this.popupOpened.bind(this));
		this.modal.addEventListener('close', this.popupClosed.bind(this));

		this.header = this.modal.querySelector('.modal-header');
		this.content = this.modal.querySelector('.modal-content');
		this.dismiss = this.modal.querySelector('[data-dismiss="modal"]');

		this.content.addEventListener('scroll', () => {
			this.modal.dataset.scroll = this.content.scrollTop;
		});

		if( this.header ) {
			this.header.addEventListener('click', this.close.bind(this));
		}

		if( this.dismiss ) {
			this.dismiss.addEventListener('click', this.close.bind(this));
		}
	}
}